module.exports = __webpack_public_path__ + "static/media/jump-page-mobile-es.cb4d84a4.png";